<template>
  <div>

    <b-card no-body style="display:block" id="listaPreebarque">
        <b-card-body>
          <div class="d-flex justify-content-between  flex-wrap">
            <!-- Registar Preembarque  -->
            <b-form-group
                label-for="filterInput"
                class="mb-0"
            >
              <b-button
                  variant="gradient-primary"
                  size="sm"
                  class="mr-1"
                  @click="listarPreembarques"
                  :disabled="loading_embarque"
                  v-b-tooltip.hover
                  title="Actualizar datos"
              >
                <feather-icon
                    icon="RefreshCwIcon"
                    :class="`${loading_embarque ? 'spinner' : ''}`"
                />
              </b-button>
              <b-button
                variant="gradient-success"
                size="sm"
                @click="descargarFile()"
              >
                <feather-icon
                    icon="PlusIcon"
                    class="mr-50"
                />
                <span class="align-middle">Exportar</span>
              </b-button>

              <b-button-group v-if="filtrando">
                            <span> Espere, Cargando Data...
                                <b-spinner style="width: 16px; height: 16px;" />
                            </span>
              </b-button-group>
            </b-form-group>
            <!-- filter -->
            <b-form-group
                label-for="filterInput"
                class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Buscar"
                />
                <b-input-group-append>
                  <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                  >
                    Borrar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

          </div>
        </b-card-body>
        <b-table
            hover
            responsive
            class="position-relative"
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="cPaginacion"
            :busy="loading_embarque"
            show-empty
            empty-text="No se encontraron datos en esta tabla."
        >
          <template #table-busy>
            <div class="text-center text-dark my-1">
              <b-spinner class="align-middle"></b-spinner> &emsp;
              <strong>Obteniendo datos...</strong>
            </div>
          </template>

          <template #cell(estado)="data">
            <b-badge  variant="light-success" v-if="data.value === 'FINALIZADO'" >
              {{ data.value }}
            </b-badge>
            <b-badge variant="light-warning" v-else>
              {{ data.value }}
            </b-badge>
          </template>

          <template #cell(transportista)="data">
            <div class="text-nowrap">
              {{ data.item.tran_conductor_name }}
              <feather-icon
                  :id="`btn_${data.item.id}_transp`"
                  icon="EyeIcon"
                  size="16"
                  class="text-info mx-1"
                  @click="mostrarModalTransporte(data.item.tran_conductor_name,
                           data.item.tran_empresa_name,
                           data.item.tran_placa_tracto,
                           data.item.tran_licencia,
                           data.item.tran_placa_carreta,
                           data.item.tran_guia_transportista)"
              />
              <b-tooltip
                  title="Ver transportista"
                  variant="info"
                  :target="`btn_${data.item.id}_transp`"
              />
              <feather-icon
                  :id="`btn_${data.item.id}_fir_tranp`"
                  icon="ImageIcon"
                  size="16"
                  class="text-info"
                  @click="verImagenFirma(data.item.tran_firma,'TRANSPORTISTA')"
              />
              <b-tooltip
                  title="Ver firma"
                  variant="info"
                  :target="`btn_${data.item.id}_fir_tranp`"
              />

            </div>
          </template>
          <template #cell(res_pre_responsable_name)="data">
            <div class="text-nowrap">
              {{ data.value }}
              <feather-icon
                  :id="`btn_${data.item.id}_fir_respo`"
                  icon="ImageIcon"
                  size="16"
                  class="text-info"
                  @click="verImagenFirma(data.item.res_pre_responsable_firma,'RESPONSABLE PRECINTADO')"
              />
              <b-tooltip
                  title="Ver firma"
                  variant="info"
                  :target="`btn_${data.item.id}_fir_respo`"
              />

            </div>
          </template>
          <template #cell(insp_contenedor_vuelo)="data">
            <div class="text-nowrap">
              {{ data.value }}
              <feather-icon
                  :id="`btn_${data.item.id}_content`"
                  icon="EyeIcon"
                  size="16"
                  class="text-info mx-1"
                  @click="mostrarModalInspeccionC(data.item.insp_contenedor_vuelo,
                            data.item.insp_hora_inicial_inspeccion,
                            data.item.insp_hora_final_inspeccion,
                            data.item.insp_numero_operacion,
                            data.item.insp_tamanio_contenedor,
                            data.item.insp_temperatura,
                            data.item.insp_precinto_llegada,
                            data.item.insp_marca_reefer,
                            data.item.insp_numero_booking,
                            data.item.insp_eir,
                            data.item.insp_year_fabricacion)"
              />
              <b-tooltip
                  title="Ver Inspección contenedor"
                  variant="info"
                  :target="`btn_${data.item.id}_content`"
              />

            </div>
          </template>

          <template #cell(revision_contenedor)="data">
            <div class="text-nowrap">
              <b-button
                  :id="`btn_${data.item.id}_ver_cont`"
                  variant="secondary"
                  class="text-info mx-1"
                  @click="mostrarModalRevision(data.item.insp_contenedor_vuelo,
                data.item.rev_limpio_residous_sim,data.item.rev_ventilador_cubierta,data.item.rev_area_comprensor,
                data.item.rev_levantamiento_deflactor,data.item.rev_dimension_contenedor,data.item.rev_7pto_1_techo_exterior,
                data.item.rev_7pto_2_lado_izquierdo,data.item.rev_7pto_3_puerta_contenedor,data.item.rev_7pto_4_piso_contenedor,
                data.item.rev_7pto_5_seccion_ext_int,data.item.rev_7pto_6_lado_derecho,data.item.rev_7pto_7_pared_delantera)"
                  size="sm"
              >
                Ver revisión
              </b-button>
              <b-tooltip
                  title="Ver revisión contenedor"
                  variant="secondary"
                  :target="`btn_${data.item.id}_ver_cont`"
              />
            </div>
          </template>
          <template #cell(precinto)="data">
            <div class="text-nowrap">
              <b-button
                  :id="`btn_${data.item.id}_ver_precinto`"
                  variant="secondary"
                  class="text-info mx-1"
                  @click="mostrarModalPrecinto(
                  data.item.insp_contenedor_vuelo,
                  data.item.est_fin_num_precinto_aduana,
                  data.item.est_fin_num_precinto_senasa,
                  data.item.est_fin_num_precinto_planta,
                  data.item.est_fin_num_precinto_operador,
                  data.item.est_fin_num_precinto_linea,
                  data.item.est_fin_otro_01_num_precinto,
                  data.item.est_fin_otro_02_num_precinto,
                  data.item.est_fin_otro_03_num_precinto,
                  data.item.est_fin_otro_04_num_precinto,
                )"
                  size="sm"
              >
                Ver precinto
              </b-button>
              <b-tooltip
                  title="Ver número de precinto"
                  variant="secondary"
                  :target="`btn_${data.item.id}_ver_precinto`"
              />
            </div>
          </template>
          <template #cell(camara)="data">
            <div class="text-nowrap">
              <b-button
                  :id="`btn_${data.item.id}_ver_camara`"
                  variant="secondary"
                  class="text-info mx-1"
                  @click="mostrarModalCamara( data.item.insp_contenedor_vuelo,
                        data.item.alm_camara_un_dias,
                        data.item.alm_camara_dos_dias,
                        data.item.alm_camara_tres_dias,
                        data.item.alm_camara_cuatro_dias,
                        data.item.alm_camara_cinco_dias,
                        data.item.alm_camara_seis_dias,
                        data.item.alm_camara_mayor_siete_dias)"
                  size="sm"
              >
                Ver alm. camara
              </b-button>
              <b-tooltip
                  title="Ver almacenamiento camara"
                  variant="secondary"
                  :target="`btn_${data.item.id}_ver_camara`"
              />
            </div>
          </template>
          <template #cell(sensor)="data">
            <div class="text-nowrap">
              <b-button
                  :id="`btn_${data.item.id}_ver_sensor`"
                  variant="secondary"
                  class="text-info mx-1"
                  @click="mostrarModalSensor(
                    data.item.insp_contenedor_vuelo,
                    data.item.sens_sensor_01_numero_pallet,
                    data.item.sens_sensor_01_value,
                    data.item.sens_sensor_02_numero_pallet,
                    data.item.sens_sensor_02_value,
                    data.item.sens_sensor_03_numero_pallet,
                    data.item.sens_sensor_03_value
                    )"
                  size="sm"
              >
                Ver sensor
              </b-button>
              <b-tooltip
                  title="Ver sensor"
                  variant="secondary"
                  :target="`btn_${data.item.id}_ver_sensor`"
              />
            </div>
          </template>

          <template #cell(distribucion_carga)="data">
            <div class="text-nowrap">
              <b-button
                  :id="`btn_${data.item.id}_ver_dis_carg`"
                  variant="secondary"
                  class="text-info mx-1"
                  @click="mostrarModal(data.item.id,'distribucion_carga',data.item.insp_contenedor_vuelo)"
                  size="sm"
              >
                Ver carga
              </b-button>
              <b-tooltip
                  title="Ver distribución carga"
                  variant="secondary"
                  :target="`btn_${data.item.id}_ver_dis_carg`"
              />
            </div>
          </template>
          <template #cell(termoregistros)="data">
            <div class="text-nowrap">
              <b-button
                  :id="`btn_${data.item.id}_ver_term`"
                  variant="secondary"
                  class="text-info mx-1"
                  @click="mostrarModal(data.item.id,'termoregistro',data.item.insp_contenedor_vuelo)"
                  size="sm"
              >
                Ver termoregistro
              </b-button>
              <b-tooltip
                  title="Ver termoregistro"
                  variant="secondary"
                  :target="`btn_${data.item.id}_ver_term`"
              />
            </div>
          </template>

          <template #cell(cuadrilla_carga)="data">
            <div class="text-nowrap">
              <b-button
                  :id="`btn_${data.item.id}_ver_cuad`"
                  variant="secondary"
                  class="text-info mx-1"
                  @click="mostrarModal(data.item.id,'cuadrilla',data.item.insp_contenedor_vuelo)"
                  size="sm"
              >
                Ver cuadrilla carga
              </b-button>
              <b-tooltip
                  title="Ver cuadrilla carga"
                  variant="secondary"
                  :target="`btn_${data.item.id}_ver_cuad`"
              />
            </div>
          </template>

          <template #cell(responsable_carga)="data">
            <div class="text-nowrap">
              <b-button
                  :id="`btn_${data.item.id}_ver_resp_carga`"
                  variant="secondary"
                  class="text-info mx-1"
                  @click="mostrarModal(data.item.id,'responsable_carga',data.item.insp_contenedor_vuelo)"
                  size="sm"
              >
                Ver responsable carga
              </b-button>
              <b-tooltip
                  title="Ver responsable carga"
                  variant="secondary"
                  :target="`btn_${data.item.id}_ver_resp_carga`"
              />
            </div>
          </template>

          <template #cell(fotografias)="data">
            <div class="text-nowrap">
              <b-button
                  :id="`btn_${data.item.id}_ver_fotografias`"
                  variant="primary"
                  class="text-info mx-1"
                  @click="mostrarNewPest(data.item.id,'fotografia',data.item.insp_contenedor_vuelo)"
                  size="sm"
              >
                Ver fotografias
              </b-button>
              <b-tooltip
                  title="Ver fotografias"
                  variant="primary"
                  :target="`btn_${data.item.id}_ver_fotografias`"
              />
            </div>
          </template>




        </b-table>
        <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
          <!-- page length -->
          <b-form-group
              label="Mostrar"
              label-cols="5"
              label-align="left"
              label-size="sm"
              label-for="sortBySelect"
              class="text-nowrap mb-md-0 mr-1"
          >
            <b-form-select
                id="perPageSelect2"
                v-model="perPage"
                size="sm"
                inline
                :options="pageOptions"
            />

          </b-form-group>

          <!-- pagination -->
          <div>
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
    </b-card>

    <div style="display:none" id="listaPallets">

      <div class="row">
        <div class="col-md-6 co-12">
          <b-card no-body >

            <b-card-body>
              <div class="d-flex justify-content-between  flex-wrap">
                <!-- Registar Empresa  -->
                <b-form-group
                    label-for="filterInput"
                    class="mb-0"
                >
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      class="mr-1"
                      @click="regresarInicio"
                      v-b-tooltip.hover="'Regresar'"
                  >
                    <feather-icon
                        icon="ArrowLeftIcon"
                    />
                  </b-button>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      class="mr-1"
                      v-b-tooltip.hover="'Actualizar'"
                      @click="listarFotografias(embarque_id,'','RECARGAR_FOT_EMBARQUE')"
                  >
                    <feather-icon
                        icon="RefreshCwIcon"
                    />

                  </b-button>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      class="mr-1"
                      v-b-tooltip.hover="'Descargar ZIP de Fotografías'"
                      @click="zipFotografias(embarque_id)"
                      :disabled="loading_zip"
                  >
                    <feather-icon
                        v-if="!loading_zip"
                        icon="DownloadIcon"
                    />
                    <feather-icon
                        v-if="loading_zip"
                        icon="RefreshCwIcon"
                        class="spinner"
                    />

                  </b-button>
                </b-form-group>


                <b-form-group
                    label-for="filterInput"
                    class="mb-0"
                    size="sm"
                >
                  <div id="clientecontent" >
                    <b>EMBARQUE: [1772-VHJ] </b>
                  </div>

                </b-form-group>

              </div>
            </b-card-body>

            <b-table
                hover
                responsive
                small
                class="position-relative"
                sticky-header="58vh"
                :current-page="currentPage"
                :items="itemsFotografias"
                :fields="fieldsFotografias"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"

                @filtered="cPaginacion"

                :busy="loading_fot"
                show-empty
                empty-text="No se encontraron datos en esta tabla."
            >
              <template #table-busy>
                <div class="text-center text-dark my-1">
                  <b-spinner class="align-middle"></b-spinner> &emsp;
                  <strong>Obteniendo datos...</strong>
                </div>
              </template>
              <template #cell(estado)="data">
                <b-badge :variant="status[1][parseInt(data.value)]">
                  {{ status[0][parseInt(data.value)] }}
                </b-badge>
              </template>
              <template #cell(total_fotografia)="data">
                <div class="text-nowrap">
                  {{ data.item.total_fotografia }}
                  <feather-icon
                      :id="`btn_${data.item.item_tipo}${data.item.item_numero}_fotogra`"
                      icon="EyeIcon"
                      size="16"
                      class="text-info mx-1"
                      @click="listarDetalleFotos(data.item.codigo_embarque,
                           data.item.item_tipo,
                           data.item.item_numero,
                           data.item.item_nombres)"
                  />
                  <b-tooltip
                      title="Ver Fotos"
                      variant="info"
                      :target="`btn_${data.item.item_tipo}${data.item.item_numero}_fotogra`"
                  />

                </div>
              </template>


              <template #cell(modulo)="data">
                {{ status_modulo[0][parseInt(data.value)] }}
              </template>
              <template #cell(created)="data">
            <span class="text-nowrap">
              {{
                new Date(data.value).toLocaleString('pe-PE', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  localeMatcher: 'best fit',
                  timeZone: 'America/Lima'
                })
              }}
            </span>
              </template>
              <template #cell(modified)="data">
            <span class="text-nowrap">
              {{
                new Date(data.value).toLocaleString('pe-PE', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  localeMatcher: 'best fit',
                  timeZone: 'America/Lima'
                })
              }}
            </span>
              </template>
              <template #cell(acciones)="data">
                <div class="text-nowrap">
                  <feather-icon
                      v-if="$can('update', 'BBSS Categorias')"
                      :id="`btn_${data.item.id}_editar`"
                      icon="EditIcon"
                      size="16"
                      class="mr-1"
                      @click="abrirModalEditar(data.item)"
                  />
                  <b-tooltip
                      title="Editar registro"
                      :target="`btn_${data.item.id}_editar`"
                  />
                </div>
              </template>
            </b-table>

          </b-card>
        </div>

        <div class="col-md-6 co-12">
          <b-card no-body >

            <b-card-body>
              <div class="d-flex justify-content-between  flex-wrap">
                <!-- Registar Empresa  -->
                <b-form-group
                    label-for="filterInput"
                    class="mb-0"
                >
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      class="mr-1"
                      @click="listarDetalleFotos(embarque_id,tipo_foto,embarque_fot_numero,'RECARGAR_FOT_EMBARQUE')"
                      v-b-tooltip.hover="'Actualizar'"
                  >
                    <feather-icon
                        icon="RefreshCwIcon"
                    />
                  </b-button>
                </b-form-group>

                <!-- filter -->
                <b-form-group
                    label-for="filterInput"
                    class="mb-0"
                    size="sm"
                >
                  <div>
                    <b>{{descripcion_item}} - FOTOGRAFÍA DE {{name_tipo_foto}}  </b>
                  </div>

                </b-form-group>

              </div>
            </b-card-body>

            <b-table
                hover
                responsive
                small
                class="position-relative"
                sticky-header="58vh"
                :current-page="currentPage"
                :items="itemsDetalleFotos"
                :fields="fieldsDetalleFotos"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"

                @filtered="cPaginacion"

                :busy="loading_Detallefot"
                show-empty
                empty-text="No se encontraron datos en esta tabla."
            >
              <template #table-busy>
                <div class="text-center text-dark my-1">
                  <b-spinner class="align-middle"></b-spinner> &emsp;
                  <strong>Obteniendo datos...</strong>
                </div>
              </template>
              <template #cell(accion)="data">
                <div class="text-nowrap">
                  <feather-icon
                      :id="`btn_${data.item.id}_ver`"
                      icon="ImageIcon"
                      size="16"
                      class="text-info mx-1"
                      @click="verImagenFotografiaEmbarque(data.item.fotcontc_file_fotografia)"
                  />
                </div>

              </template>

            </b-table>

          </b-card>
        </div>


      </div>
    </div>


    <b-modal
        id="modalResumenCategoria"
        v-model="estadoModalDetalleEmbarque"
        :title="infoModal.titleDetalleEmbarque"
        hide-footer
        size="lg"
    >
      <b-card
          class="card-transaction"
          no-body
      >
        <b-card-header>
          <br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span>{{name_detalle_modal}}</span>
          <b-dropdown
              variant="link"
              no-caret
              class="chart-dropdown"
              toggle-class="p-0"
              right
          >
            <template #button-content>
            </template>
          </b-dropdown>

        </b-card-header>
        <b-card-body>
          <b-table
              hover
              responsive
              class="position-relative"
              :items="itemsResumenDetalle"
              :fields="fieldsResumenDetalle"
              :busy="loading_detalle"
              show-empty
              empty-text="No se encontraron datos."
              id="table-resumen"
              foot-clone
          >
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(firma)="data">
              <div v-if="data.item.firma_url != null">
                <div class="text-nowrap">
                  <feather-icon
                      :id="`btn_${data.item.id}_ver`"
                      icon="ImageIcon"
                      size="16"
                      class="text-info mx-1"
                      @click="verImagenFirma(data.item.firma_url,data.item.titlef)"
                  />
                </div>
              </div>
              <div style="color: red" v-else >
                NO
              </div>

            </template>

            <template #foot()="data" >
            </template>

          </b-table>
        </b-card-body>


      </b-card>

    </b-modal>

    <b-modal id="modalPopover" ok-only  v-model="estadoModalFirma"  size="sm"  :title="infoModalFirma.title"  hide-footer>

      <b-card

      >
        <div class="text-center text-dark my-1" v-if="estadoModalLoadingFirmaImg" >
          <b-spinner class="align-middle"></b-spinner> &emsp;
          <strong>Obteniendo datos...</strong>
        </div>

        <img :src="src_firma" class="img-fluid" alt="..."  v-else >
      </b-card>

    </b-modal>

  </div>

</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol,
  BSpinner,
  VBTooltip,
  BButtonGroup
} from 'bootstrap-vue'
import axios from "axios";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { heightFade } from '@core/directives/animations'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BSpinner,
    BButtonGroup
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {

      perPage: 10,
      pageOptions: [5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      loading_fot:false,
      loading_Detallefot:false,
      filter: null,
      filterOn: [],
      filtrando:false,
      estadoModal: false,
      estadoModalDetalleEmbarque:false,
      src_firma: '',
      name_detalle_modal:'',
      descripcion_detalle:'',
      infoModal: {
        title: '',
        boton: '',
        titleDetalleEmbarque:'',
      },
      infoModalFirma: {
        title: '',
      },
      estadoModalFirma:false,
      estadoModalLoadingFirmaImg:false,
      loading_detalle:false,
      loading_embarque:false,
      loading_zip:false,
      descripcion_item:"",
      name_tipo_foto:"CONTROL",
      embarque_id :"",
      tipo_foto :"",
      embarque_fot_numero :"",

      items: [],
      fields: [
        {
          key: 'insp_contenedor_vuelo',
          label: 'CONTENEDOR',
          sortable: true
        },
        {
          key: 'inf_fecha_despacho',
          label: 'Fecha_Despacho',
          sortable: true,
          tdClass: 'alinear-una-sola-linea'

        },
        {
          key: 'inf_tratatamiento_despacho',
          label: 'Tratamiento_despacho',
          sortable: true
        },
        {
          key: 'inf_planta_procesadora',
          label: 'Planta',
          sortable: true
        },
        {
          key: 'inf_tipo_estiba',
          label: 'Estiba',
          sortable: true
        },
        {
          key: 'inf_embarque',
          label: 'Embarque',
          sortable: true
        },
        {
          key: 'inf_cultivo',
          label: 'Cultivo',
          sortable: true
        },
        {
          key: 'inf_cliente_name',
          label: 'NOMBRES_Cliente',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'inf_numero_rampa',
          label: 'Rampa',
          sortable: true
        },
        {
          key: 'dest_fecha_destino_etd',
          label: 'Destino_etd',
          sortable: true
        },
        {
          key: 'dest_fecha_destino_eta',
          label: 'Destino_eta',
          sortable: true
        },
        {
          key: 'dest_naviera_areolinea',
          label: 'Naviera',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'dest_puerto_llegada',
          label: 'Puerto_llegada',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'dest_puerto_salida',
          label: 'Puerto_salida',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'atm_tecnologia_descripcion',
          label: 'Tecnologia',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'atm_ventilacion',
          label: 'Ventilacion',
          sortable: true
        },
        {
          key: 'atm_cortina_ac',
          label: 'Cortina',
          sortable: true
        },
        {
          key: 'atm_cal_apagada',
          label: 'Cal_apagada',
          sortable: true
        },
        {
          key: 'atm_filtro_etileno',
          label: 'Filtro_etileno',
          sortable: true
        },
        {
          key: 'atm_co2',
          label: 'Co2',
          sortable: true
        },
        {
          key: 'atm_02',
          label: '02',
          sortable: true
        },
        {
          key: 'tem_apertura',
          label: 'Apertura',
          sortable: true
        },
        {
          key: 'tem_corte',
          label: 'Corte',
          sortable: true
        },
        {
          key: 'tem_pulpa_minima',
          label: 'Pulpa_minima',
          sortable: true
        },
        {
          key: 'tem_pulpa_maxima',
          label: 'Pulpa_Maxima',
          sortable: true
        },
        {
          key: 'desp_hora_inicial_carga',
          label: 'carga_hora_inicial',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'desp_hora_termino_carga',
          label: 'carga_hora_termino',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'desp_guia_remision',
          label: 'Guia_remision',
          sortable: true
        },
        {
          key: 'desp_carga_remision',
          label: 'carga_remision',
          sortable: true
        },
        {
          key: 'transportista',
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'revision_contenedor',
          label: 'revision_contenedor',
        },
        {
          key: 'precinto',
        },
        {
          key: 'camara',
        },
        {
          key: 'res_pre_responsable_name',
          label: 'Responsable_precintado',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'res_pre_responsable_dni',
          label: 'DNI',
          sortable: true
        },
        {
          key: 'sensor',
        },
        {
          key: 'distribucion_carga',
          label: 'distribucion_carga',
        },
        {
          key: 'termoregistros',
        },
        {
          key: 'cuadrilla_carga',
        },
        {
          key: 'responsable_carga',
        },
        {
          key: 'fotografias'
        },
        {
          key: 'estado',
          label: 'estado',
          sortable: true
        },
      ],
      itemsResumenDetalle:[],
      fieldsResumenDetalle:[],
      itemsFotografias: [],
      fieldsFotografias: [
        {
          key: 'item_tipo',
          label: 'Tipo',
          sortable: true
        },
        {
          key: 'item_numero',
          label: 'Item',
          sortable: true
        },
        {
          key: 'item_nombres',
          label: 'Descripcion',
          sortable: true
        },

        {
          key: 'total_fotografia',
          label: 'fotografias',
          sortable: true
        },
      ],
      fieldsTermoregistro: [
        {
          key: 'term_numero_pallet',
          label: 'numero pallet',
          sortable: true
        },
        {
          key: 'term_termoregistro_value',
          label: 'termoregistro value',
          sortable: true
        },
        {
          key: 'term_fecha_creacion',
          label: 'fecha creacion',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
      ],
      fieldsDisCarga: [
        {
          key: 'dis_carga_orden_pallet',
          label: 'orden_pallet',
          sortable: true
        },
        {
          key: 'dis_carga_numero_pallet',
          label: 'numero_pallet',
          sortable: true
        },
        {
          key: 'dis_carga_temperatura_pallet',
          label: 'temperatura_pallet',
          sortable: true
        },
        {
          key: 'termoregistro_pallet',
          label: 'termoregistro_pallet',
          sortable: true
        },
        {
          key: 'sensor_pallet',
          label: 'sensor_pallet',
          sortable: true
        },
      ],
      fieldsRespCarga: [
        {
          key: 'respon_carga_tipo',
          label: 'tipo',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'respon_carga_fotocheck',
          label: 'fotocheck',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'respon_carga_apellidos',
          label: 'apellidos',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'respon_carga_nombres',
          label: 'nombres',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'creacion',
          label: 'creacion',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'firma',
          label: 'firma',
          sortable: true
        },
      ],
      fieldsCuadrillaCarga: [
        {
          key: 'cuad_carga_tipo',
          label: 'tipo',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'cuad_carga_fotocheck',
          label: 'fotocheck',
          sortable: true
        },
        {
          key: 'cuad_carga_apellidos',
          label: 'apellidos',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'cuad_carga_nombres',
          label: 'nombres',
          tdClass: 'alinear-una-sola-linea',
          sortable: true
        },
        {
          key: 'creacion',
          label: 'creación',
          sortable: true
        },
        {
          key: 'firma',
          label: 'firma',
        },
      ],
      itemsDetalleFotos: [],
      fieldsDetalleFotos: [
        {
          key: 'fotcontc_fecha_hora_toma_foto',
          label: 'FECHA_HORA_TOMA',
          sortable: true
        },
        {
          key: 'fotcontc_fecha_hora_registro',
          label: 'FECHA_HORA_REGISTRO',
          sortable: true
        },
        {
          key: 'accion',
          label: 'accion',
          sortable: true
        },
      ],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
  },
  mounted() {
    this.listarPreembarques();
  },
  methods: {
    listarPreembarques(){
      var yo = this

      yo.loading_embarque = true;
      yo.filtrando = true;
      var config = {
        method: 'get',
        url: '/calidad/embarque/all/view/'
      };

      axiosIns(config)
      .then((response) => {
          yo.items = response.data.response;

          yo.totalRows = yo.items.length
        console.log(yo.items);
      })
      .catch(function (error) {
        console.log(error);
      }) .finally(function () {
        yo.loading_embarque = false;
        yo.filtrando = false;
        yo.mostrarNotificacion('Correcto', 'CheckIcon', 'Los Datos se Leyeron Correctamente', 'success')
      });
    },

    listarFotografias(id,cliente,numero_operacion){

      var yo = this
      this.loading_fot = true;
      this.itemsDetalleFotos=[];
      if(numero_operacion !="RECARGAR_FOT_EMBARQUE"){
        const div1 = document.querySelector('#listaPreebarque');
        const div2 = document.querySelector('#listaPallets');
        const divCliente = document.querySelector('#clientecontent');
        if (div1.style.display === "block") {
          div1.style.display = "none";
          div2.style.display = "block";
        }
        divCliente.innerHTML=""
        divCliente.innerHTML="<b>"+cliente+"  -  N° EMBARQUE ["+ numero_operacion+"]</b>"
        yo.embarque_id = id;
      }



      var config = {
        method: 'get',
        url: '/calidad/fotografia/embarque/list/all/?codigo_embarque='+id
      };


      axiosIns(config)
          .then(function (response) {
            yo.itemsFotografias = response.data.response;
            console.log(yo.itemsFotografias)
            // yo.totalRows = yo.itemsPallets.length
            // console.log(yo.itemsPallets);
          })
          .catch(function (error) {
            console.log(error);
          }).finally(function (){
            yo.loading_fot = false
          });
    },

    listarDetalleFotos(id,tipo,numero_item,descripcion){

      this.loading_Detallefot = true;
      var yo = this
      if(descripcion !="RECARGAR_FOT_EMBARQUE"){
        this.name_tipo_foto = tipo;
        this.descripcion_item = descripcion;
        yo.tipo_foto = tipo;
        yo.embarque_fot_numero = numero_item;
      }




      var config = {
        method: 'get',
        url: '/calidad/detalle/fotografia/embarque/list/all/?codigo_embarque='+id+'&tipo='+tipo+"&numero_item="+numero_item
      };


      axiosIns(config)
          .then(function (response) {
            yo.itemsDetalleFotos = response.data.response;
            //console.log(yo.itemsPallets);
          })
          .catch(function (error) {
            console.log(error);
          }).finally(function (){
        yo.loading_Detallefot = false
      });
    },
    async zipFotografias(id){
      const yo = this;
      yo.loading_zip = true;

      const divCliente = document.querySelector('#clientecontent');
      const texto = divCliente.querySelector('b').textContent;
      const regex = /\[(.*?)\]/;
      const resultado = texto.match(regex);

      let filename_zip = "container_photos.zip"
      if (resultado) {
        filename_zip = resultado[1].replace(/[\\\/:*?"<>|]/g, '_')+".zip";   // Muestra: 996-13798374
      }
      var config = {
        method: 'GET',
        url: `/calidad/fotografia/embarque/zip/all/?codigo_embarque=${id}`,
        responseType: 'blob',
      };
      try {
        const response = await axiosIns(config);

        if (response.status === 200) {
          // Crea un enlace para descargar el archivo ZIP
          const blob = new Blob([response.data], { type: 'application/zip' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename_zip; // Nombre del archivo ZIP
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Mensaje de éxito
          yo.$toast({
            component: ToastificationContent,
            props: {
              title: 'Archivo comprimido generado',
              icon: 'CheckIcon',
              text: 'El archivo comprimido con las fotos se descargó correctamente.',
              variant: 'success',
            },
          });
        }
      } catch (error) {
        console.error('Error al generar archivo comprimido:', error);
        yo.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'XIcon',
            text: 'Hubo un error al generar el archivo comprimido. Por favor, inténtelo nuevamente.',
            variant: 'danger',
          },
        });
      } finally {
        yo.loading_zip = false; // Desactiva el spinner
      }
    },


    cPaginacion(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    mostrarModalRevision(insp_contenedor_vuelo,
                         rev_limpio_residous_sim,
                         rev_ventilador_cubierta,
                         rev_area_comprensor,
                         rev_levantamiento_deflactor,
                         rev_dimension_contenedor,
                         rev_7pto_1_techo_exterior,
                         rev_7pto_2_lado_izquierdo,
                         rev_7pto_3_puerta_contenedor,
                         rev_7pto_4_piso_contenedor,
                         rev_7pto_5_seccion_ext_int,
                         rev_7pto_6_lado_derecho,
                         rev_7pto_7_pared_delantera){

      try {
        this.loading_detalle = true;
        this.estadoModalDetalleEmbarque = true;
        this.infoModal.titleDetalleEmbarque = "REVISION DE CONTENEDOR";
        this.name_detalle_modal = "N° CONTENEDOR:  "+insp_contenedor_vuelo;

        this.fieldsResumenDetalle = [
          {
            key: 'rev_limpio_residous_sim',
            label: 'Limpio sin residous',
            sortable: true
          },
          {
            key: 'rev_ventilador_cubierta',
            label: 'ventilador cubierta',
            sortable: true
          },
          {
            key: 'rev_area_comprensor',
            label: 'area comprensor',
            sortable: true
          },
          {
            key: 'rev_levantamiento_deflactor',
            label: 'levantamiento deflactor',
            sortable: true
          },
          {
            key: 'rev_dimension_contenedor',
            label: 'dimension contenedor',
            sortable: true
          },
          {
            key: 'rev_7pto_1_techo_exterior',
            label: 'Pto 1 techo exterior',
            sortable: true
          },
          {
            key: 'rev_7pto_2_lado_izquierdo',
            label: 'Pto 2 lado izquierdo',
            sortable: true
          },
          {
            key: 'rev_7pto_3_puerta_contenedor',
            label: 'Pto 3 puerta contenedor',
            sortable: true
          },
          {
            key: 'rev_7pto_4_piso_contenedor',
            label: 'Pto 4 piso contenedor',
            sortable: true
          },
          {
            key: 'rev_7pto_5_seccion_ext_int',
            label: 'Pto 5 seccion ext. int.',
            sortable: true
          },
          {
            key: 'rev_7pto_6_lado_derecho',
            label: 'Pto 6 lado derecho',
            sortable: true
          },
          {
            key: 'rev_7pto_7_pared_delantera',
            label: 'Pto 7 pared delantera',
            sortable: true
          },
        ];

        this.itemsResumenDetalle = [
          {
            "rev_limpio_residous_sim":rev_limpio_residous_sim,
            "rev_ventilador_cubierta":rev_ventilador_cubierta,
            "rev_area_comprensor":rev_area_comprensor,
            "rev_levantamiento_deflactor":rev_levantamiento_deflactor,
            "rev_dimension_contenedor":rev_dimension_contenedor,
            "rev_7pto_1_techo_exterior":rev_7pto_1_techo_exterior,
            "rev_7pto_2_lado_izquierdo":rev_7pto_2_lado_izquierdo,
            "rev_7pto_3_puerta_contenedor":rev_7pto_3_puerta_contenedor,
            "rev_7pto_4_piso_contenedor":rev_7pto_4_piso_contenedor,
            "rev_7pto_5_seccion_ext_int":rev_7pto_5_seccion_ext_int,
            "rev_7pto_6_lado_derecho":rev_7pto_6_lado_derecho,
            "rev_7pto_7_pared_delantera":rev_7pto_7_pared_delantera,
          }
        ];

      }
      catch (error) {
        const errorMessage = buildErrorMessage(error);
        this.$store.commit("errorMessage", errorMessage);
        this.$store.commit("errorModal", true);
      }
      finally {
        this.loading_detalle = false
        this.$store.commit("isLoading", false);
      }

    },

    mostrarModalPrecinto(insp_contenedor_vuelo,
                         est_fin_num_precinto_aduana,
                         est_fin_num_precinto_senasa,
                         est_fin_num_precinto_planta,
                         est_fin_num_precinto_operador,
                         est_fin_num_precinto_linea,
                         est_fin_otro_01_num_precinto,
                         est_fin_otro_02_num_precinto,
                         est_fin_otro_03_num_precinto,
                         est_fin_otro_04_num_precinto){

      try {
        this.loading_detalle = true;
        this.estadoModalDetalleEmbarque = true;
        this.infoModal.titleDetalleEmbarque = "PRECINTOS DE CONTENEDOR";
        this.name_detalle_modal = "N° CONTENEDOR:  "+insp_contenedor_vuelo;

        this.fieldsResumenDetalle = [
          {
            key: 'est_fin_num_precinto_aduana',
            label: 'precinto_aduana',
            sortable: true
          },
          {
            key: 'est_fin_num_precinto_senasa',
            label: 'precinto_senasa',
            sortable: true
          },
          {
            key: 'est_fin_num_precinto_planta',
            label: 'precinto_planta',
            sortable: true
          },
          {
            key: 'est_fin_num_precinto_operador',
            label: 'precinto_operador',
            sortable: true
          },
          {
            key: 'est_fin_num_precinto_linea',
            label: 'precinto_linea',
            sortable: true
          },
          {
            key: 'est_fin_otro_01_num_precinto',
            label: 'otro_01_precinto',
            sortable: true
          },
          {
            key: 'est_fin_otro_02_num_precinto',
            label: 'otro_02_precinto',
            sortable: true
          },
          {
            key: 'est_fin_otro_03_num_precinto',
            label: 'otro_03_precinto',
            sortable: true
          },
          {
            key: 'est_fin_otro_04_num_precinto',
            label: 'otro_04_precinto',
            sortable: true
          },
        ];

        this.itemsResumenDetalle = [
          {
            "est_fin_num_precinto_aduana":est_fin_num_precinto_aduana,
            "est_fin_num_precinto_senasa":est_fin_num_precinto_senasa,
            "est_fin_num_precinto_planta":est_fin_num_precinto_planta,
            "est_fin_num_precinto_operador":est_fin_num_precinto_operador,
            "est_fin_num_precinto_linea":est_fin_num_precinto_linea,
            "est_fin_otro_01_num_precinto":est_fin_otro_01_num_precinto,
            "est_fin_otro_02_num_precinto":est_fin_otro_02_num_precinto,
            "est_fin_otro_03_num_precinto":est_fin_otro_03_num_precinto,
            "est_fin_otro_04_num_precinto":est_fin_otro_04_num_precinto,
          }
        ];

      }
      catch (error) {
        const errorMessage = buildErrorMessage(error);
        this.$store.commit("errorMessage", errorMessage);
        this.$store.commit("errorModal", true);
      }
      finally {
        this.loading_detalle = false
        this.$store.commit("isLoading", false);
      }

    },

    mostrarModalCamara(insp_contenedor_vuelo,
                       alm_camara_un_dias,
                       alm_camara_dos_dias,
                       alm_camara_tres_dias,
                       alm_camara_cuatro_dias,
                       alm_camara_cinco_dias,
                       alm_camara_seis_dias,
                       alm_camara_mayor_siete_dias){

      try {
        this.loading_detalle = true;
        this.estadoModalDetalleEmbarque = true;
        this.infoModal.titleDetalleEmbarque = "ALMACENAMIENTO EN CAMARA";
        this.name_detalle_modal = "N° CONTENEDOR:  "+insp_contenedor_vuelo;

        this.fieldsResumenDetalle = [
          {
            key: 'alm_camara_un_dias',
            label: 'Un_dia',
            sortable: true
          },
          {
            key: 'alm_camara_dos_dias',
            label: 'Dos_dias',
            sortable: true
          },
          {
            key: 'alm_camara_tres_dias',
            label: 'tres_dias',
            sortable: true
          },
          {
            key: 'alm_camara_cuatro_dias',
            label: 'cuatro_dias',
            sortable: true
          },
          {
            key: 'alm_camara_cinco_dias',
            label: 'cinco_dias',
            sortable: true
          },
          {
            key: 'alm_camara_seis_dias',
            label: 'seis_dias',
            sortable: true
          },
          {
            key: 'alm_camara_mayor_siete_dias',
            label: 'mayor_siete_dias',
            sortable: true
          },
        ];

        this.itemsResumenDetalle = [
          {
            "alm_camara_un_dias":alm_camara_un_dias,
            "alm_camara_dos_dias":alm_camara_dos_dias,
            "alm_camara_tres_dias":alm_camara_tres_dias,
            "alm_camara_cuatro_dias":alm_camara_cuatro_dias,
            "alm_camara_cinco_dias":alm_camara_cinco_dias,
            "alm_camara_seis_dias":alm_camara_seis_dias,
            "alm_camara_mayor_siete_dias":alm_camara_mayor_siete_dias
          }
        ];

      }
      catch (error) {
        const errorMessage = buildErrorMessage(error);
        this.$store.commit("errorMessage", errorMessage);
        this.$store.commit("errorModal", true);
      }
      finally {
        this.loading_detalle = false
        this.$store.commit("isLoading", false);
      }

    },


    mostrarModalSensor(insp_contenedor_vuelo,
                       sens_sensor_01_numero_pallet,
                       sens_sensor_01_value,
                       sens_sensor_02_numero_pallet,
                       sens_sensor_02_value,
                       sens_sensor_03_numero_pallet,
                       sens_sensor_03_value){

      try {
        this.loading_detalle = true;
        this.estadoModalDetalleEmbarque = true;
        this.infoModal.titleDetalleEmbarque = "SENSORES";
        this.name_detalle_modal = "N° CONTENEDOR:  "+insp_contenedor_vuelo;

        this.fieldsResumenDetalle = [
          {
            key: 'sens_sensor_01_value',
            label: 'sensor_01_value',
            sortable: true
          },
          {
            key: 'sens_sensor_02_value',
            label: 'sensor_02_value',
            sortable: true
          },
          {
            key: 'sens_sensor_03_value',
            label: 'sensor_03_value',
            sortable: true
          },
        ];

        this.itemsResumenDetalle = [
          {
            "sens_sensor_01_value":sens_sensor_01_value,
            "sens_sensor_02_value":sens_sensor_02_value,
            "sens_sensor_03_value":sens_sensor_03_value
          }
        ];

      }
      catch (error) {
        const errorMessage = buildErrorMessage(error);
        this.$store.commit("errorMessage", errorMessage);
        this.$store.commit("errorModal", true);
      }
      finally {
        this.loading_detalle = false
        this.$store.commit("isLoading", false);
      }

    },

    mostrarModalInspeccionC(insp_contenedor_vuelo,
                            insp_hora_inicial_inspeccion,
                            insp_hora_final_inspeccion,
                            insp_numero_operacion,
                            insp_tamanio_contenedor,
                            insp_temperatura,
                            insp_precinto_llegada,
                            insp_marca_reefer,
                            insp_numero_booking,
                            insp_eir,
                            insp_year_fabricacion){

      try {
        this.loading_detalle = true;
        this.estadoModalDetalleEmbarque = true;
        this.infoModal.titleDetalleEmbarque = "INSPECCIÓN CONTENEDOR";
        this.name_detalle_modal = "N° CONTENEDOR:  "+insp_contenedor_vuelo;

        this.fieldsResumenDetalle = [
          {
            key: 'insp_hora_inicial_inspeccion',
            label: 'hora_inicial',
            sortable: true
          },
          {
            key: 'insp_hora_final_inspeccion',
            label: 'hora_final',
            sortable: true
          },
          {
            key: 'insp_numero_operacion',
            label: 'numero_operacion',
            sortable: true
          },
          {
            key: 'insp_tamanio_contenedor',
            label: 'tamaño_contenedor',
            sortable: true
          },
          {
            key: 'insp_temperatura',
            label: 'temperatura',
            sortable: true
          },
          {
            key: 'insp_precinto_llegada',
            label: 'precinto_llegada',
            sortable: true
          },
          {
            key: 'insp_marca_reefer',
            label: 'marca_reefer',
            sortable: true
          },
          {
            key: 'insp_numero_booking',
            label: 'booking',
            sortable: true
          },

          {
            key: 'insp_eir',
            label: 'eir',
            sortable: true
          },

          {
            key: 'insp_year_fabricacion',
            label: 'fabricacion',
            sortable: true
          },
        ];

        this.itemsResumenDetalle = [
          {
            "insp_hora_inicial_inspeccion":insp_hora_inicial_inspeccion,
            "insp_hora_final_inspeccion":insp_hora_final_inspeccion,
            "insp_numero_operacion":insp_numero_operacion,
            "insp_tamanio_contenedor":insp_tamanio_contenedor,
            "insp_temperatura":insp_temperatura,
            "insp_precinto_llegada":insp_precinto_llegada,
            "insp_marca_reefer":insp_marca_reefer,
            "insp_numero_booking":insp_numero_booking,
            "insp_eir":insp_eir,
            "insp_year_fabricacion":insp_year_fabricacion
          }
        ];

      }
      catch (error) {
        const errorMessage = buildErrorMessage(error);
        this.$store.commit("errorMessage", errorMessage);
        this.$store.commit("errorModal", true);
      }
      finally {
        this.loading_detalle = false
        this.$store.commit("isLoading", false);
      }

    },

    mostrarModalTransporte(tran_conductor_name,
                           tran_empresa_name,
                           tran_placa_tracto,
                           tran_licencia,
                           tran_placa_carreta,
                           tran_guia_transportista){

      try {
        this.loading_detalle = true;
        this.estadoModalDetalleEmbarque = true;
        this.infoModal.titleDetalleEmbarque = "DETALLE TRANSPORTISTA";
        this.name_detalle_modal = "TRANSPORTISTA:  "+tran_conductor_name;

        this.fieldsResumenDetalle = [
          {
            key: 'tran_empresa_name',
            label: 'empresa',
            sortable: true
          },
          {
            key: 'tran_placa_tracto',
            label: 'placa_tracto',
            sortable: true
          },
          {
            key: 'tran_licencia',
            label: 'licencia',
            sortable: true
          },
          {
            key: 'tran_placa_carreta',
            label: 'placa_carreta',
            sortable: true
          },
          {
            key: 'tran_guia_transportista',
            label: 'guia_transportista',
            sortable: true
          },
        ];

        this.itemsResumenDetalle = [
          {
            "tran_empresa_name":tran_empresa_name,
            "tran_placa_tracto":tran_placa_tracto,
            "tran_licencia":tran_licencia,
            "tran_placa_carreta":tran_placa_carreta,
            "tran_guia_transportista":tran_guia_transportista
          }
        ];

      }
      catch (error) {
        const errorMessage = buildErrorMessage(error);
        this.$store.commit("errorMessage", errorMessage);
        this.$store.commit("errorModal", true);
      }
      finally {
        this.loading_detalle = false
        this.$store.commit("isLoading", false);
      }

    },

    mostrarModal(id,table,valor){

      var yo = this
      this.loading_detalle = true;
      this.estadoModalDetalleEmbarque = true;
      this.name_detalle_modal = "N° CONTENEDOR:  "+valor;
      this.infoModal.titleDetalleEmbarque = "";

      var url = "";
      if (table == "termoregistro"){
        this.infoModal.titleDetalleEmbarque = "TERMOREGISTRO";
        url = "/calidad/embarque/all/termoregistro/byid/";
        yo.fieldsResumenDetalle = yo.fieldsTermoregistro;
      }else if (table == "cuadrilla"){
        url = "/calidad/embarque/all/cuadrilla/byid/";
        yo.fieldsResumenDetalle = this.fieldsCuadrillaCarga;
        this.infoModal.titleDetalleEmbarque = "CUADRILLA CARGA";
      }else if (table == "responsable_carga"){
        url = "/calidad/embarque/all/responsable_carga/byid/";
        yo.fieldsResumenDetalle = this.fieldsRespCarga;
        this.infoModal.titleDetalleEmbarque = "RESPONSABLE CARGA";
      }else if (table == "distribucion_carga"){
        url = "/calidad/embarque/all/distribucion_carga/byid/";
        yo.fieldsResumenDetalle = this.fieldsDisCarga;
        this.infoModal.titleDetalleEmbarque = "DISTRIBUCION CARGA";
      }

      yo.itemsResumenDetalle = [];
      var config = {
        method: 'get',
        url: url+'?codigo_embarque='+id
      };

      axiosIns(config)
          .then((response) => {
            yo.itemsResumenDetalle = response.data.response;


            console.log(yo.items);
          })
          .catch(function (error) {
            console.log(error);
          }) .finally(function () {
              yo.loading_detalle = false;
          });




    },
    mostrarNewPest(id,cliente,numero_operación){
      this.listarFotografias(id,cliente,numero_operación);
    },

    regresarInicio(){
      const div1 = document.querySelector('#listaPreebarque');
      const div2 = document.querySelector('#listaPallets');
      if (div1.style.display === "none") {
        div1.style.display = "block";
        div2.style.display = "none";
      }
    },

    verImagenPulpa(url){
      this.estadoModal = true;
      this.infoModal.title = "Fotografía de Temperatura Pulpa";
      var urlImagenPul = "http://prd-cloud.agvperu.com/media/"+url;
      this.src= urlImagenPul;


    },

    verImagenFotografiaEmbarque(url){

      this.estadoModalFirma = true;
      this.estadoModalLoadingFirmaImg = true
      this.infoModalFirma.title = "Fotografia(s) de "+this.descripcion_item;

      var urlImagenFirma = "https://prd-cloud.agvperu.com/media/"+url;

      this.src_firma= urlImagenFirma;
      this.estadoModalLoadingFirmaImg=false
    },

    verImagenFirma(url,title){
      this.estadoModalFirma = true;
      this.infoModalFirma.title = "FIRMA DE "+title;

      var urlImagenFirma = "https://prd-cloud.agvperu.com/media/"+url;

      this.src_firma= urlImagenFirma;
    },

    descargarFile(){
      var yo = this

      var config = {
        method: 'GET',
        url: '/calidad/embarque/exportAll/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer'
      };
      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              console.log("Enviado")

              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'Lista de embarques.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Archivo creado',
                  icon: 'CheckIcon',
                  text: 'El archivo se creó satisfactoriamente.',
                  variant: 'success',
                },
              },
                  {
                    position: 'top-center',
                  })
            }
            else if(response.status === 204){
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'No existen registros',
                  icon: 'AlertTriangleIcon',
                  text: 'No se encontraron registros con los parámetros solicitados.',
                  variant: 'warning',
                },
              })
            }

          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          });


    },

    mostrarNotificacion(titulo, icono, texto, variante){
      this.$toast({
        component: ToastificationContent,
        props:{
          title: titulo,
          icon: icono,
          text: texto,
          variant: variante
        }
      },
      {
        timeout: 5000
      })
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.boton = ''
      this.estadoModal = false
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.alinear-una-sola-linea {
  white-space: nowrap !important;
}

</style>
